var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "toast",
      staticClass: "app-toast",
      class: [_vm.state],
      on: { transitionend: _vm.transitionEnded }
    },
    [
      _vm.message.icon
        ? _c(
            "div",
            { staticClass: "toast-icon" },
            [_c("app-icon", { attrs: { name: _vm.message.icon } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "toast-content" },
        [
          _vm._t("default", function() {
            return [
              _c("div", {
                staticClass: "toast-body",
                domProps: { innerHTML: _vm._s(_vm.message.body) }
              })
            ]
          }),
          _vm._v(" "),
          _c("div", { staticClass: "toast-time" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("date.ago", { time: _vm.since })) +
                "\n    "
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "close-btn", on: { click: _vm.close } })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }